import React from "react";
import { connect } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { ViewCarousel } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { format } from "date-fns";

class Index extends React.Component {
  state = {
    detailModel: false,
    selectedId: null,
  };

  handleCustomDatum = (item) => {
    return format(new Date(item.created_at), "dd-MM-yyyy HH:mm:ss");
  };

  render() {
    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Sms log"} tKey={"smslog.pagetitle"} />} />

        <GridContainer>
          <VestigingenFilter />
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "vestiging.naam", editable: false },
                { dbfield: "to", editable: false },
                { dbfield: "message", editable: false },
                { dbfield: "status", editable: false },
                { customData: this.handleCustomDatum },
              ]}
              dbfields={"id,vestiging_id,vestiging.id,vestiging.naam,to,message,status,created_at"}
              fetchUrl={"core/smslog"}
              filters={this.props.filters}
              headerIcon={<ViewCarousel />}
              headers={[
                {
                  label: getTranslation("smslog.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("smslog.table.vestiging", "Vestiging"),
                  sortable: true,
                  sortKey: "vestiging.naam",
                },
                { label: getTranslation("smslog.table.to", "Naar"), sortable: false },
                {
                  label: getTranslation("smslog.table.message", "Bericht"),
                  sortable: false,
                },
                {
                  label: getTranslation("smslog.table.status", "Status"),
                  sortable: true,
                  sortKey: "status",
                },
                {
                  label: getTranslation("smslog.table.created_at", "Aangemaakt"),
                  sortable: true,
                  sortKey: "created_at",
                },
              ]}
              reduxKey={"smslog"}
              showAutoRenew
              tableTitle={<TranslationWrapper tDefault={"smslog"} tKey={"smslog.table.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  return {
    filters: getVestigingFilterState(state, true),
  };
};

export default connect(mapStateToProps)(withStyles(Index, tafelStyle));
